export default {
  email: "{field}格式不正確",
  required: "請填寫{field}",
  numeric: "{field}格式不正確",
  unknown: "發生問題，請重新整理後再試一次。如果問題仍然持續，請電郵至support{'@'}edcity.hk。",
  image: "{field} 不是可識別的圖像文件格式。",
  imageSize: "{field} 的檔案大小超過5MB限制。",
  recaptcha: "請驗證您不是自動程式。",
  sameAs: "{field} 與 {sameAsField} 不相同",
  maxLength: "{field} 的最大長度已超過",
  verifyCode:{
    invalid: "驗證碼錯誤。",
    expired: "驗證碼已逾時，請返回重新發送。",
    notFound:"找不到對應記錄，請返回重新發送。",
    emailDuplicate:"電郵地址已用於其他教城帳戶作登入電郵，請返回後用其他電郵地址重新發送。",
    sixDigit: "{field} 必須是六位數字。"
  },
};
